import {
  fireHydrantIcon,
  noParkingIcon,
  speedLimitIconGeneric,
  stopSignIcon,
  trafficLightIcon,
  turnRuleIcon,
  turnRuleEUIcon,
  signIcon,
  highwaySignIcon,
  speedSignEUIcon,
  trafficFlowIcon,
  oneWaySignIcon,
  yieldSignIcon,
  deadEndSignIcon,
  roadClosedSignIcon,
} from '@/components/ui/icons/map/trackedCell';
import { ClassLabel } from './label';

export const CLASS_LABEL_ICONS: Partial<Record<ClassLabel, string>> = {
  'fire-hydrant': fireHydrantIcon(),
  'unknown-sign': signIcon(),
  'traffic-light': trafficLightIcon(),
  'speed-sign': speedLimitIconGeneric(),
  'parking-restriction': noParkingIcon(),
  'stop-sign': stopSignIcon(),
  'turn-rules-sign': turnRuleIcon(),
  'highway-sign': highwaySignIcon(),
  'speed-sign-eu': speedSignEUIcon(),
  'turn-rules-eu': turnRuleEUIcon(),
  'movement-regulation-sign': trafficFlowIcon(),
  'one-way-sign': oneWaySignIcon,
  'yield-sign': yieldSignIcon,
  'road-closed-sign': roadClosedSignIcon,
  'dead-end-sign': deadEndSignIcon,
};

export const CLASS_LABEL_ICONS_GRAYSCALE: Partial<Record<ClassLabel, string>> =
  {
    'fire-hydrant': fireHydrantIcon(true),
    'traffic-light': trafficLightIcon(true),
    'speed-sign': speedLimitIconGeneric(true),
    'parking-restriction': noParkingIcon(true),
    'stop-sign': stopSignIcon(true),
    'turn-rules-sign': turnRuleIcon(true),
    'turn-rules-eu': turnRuleIcon(true),
  };

export const CLASS_LABEL_ICONS_MAP_FEATURE: Partial<
  Record<ClassLabel, string>
> = {
  'fire-hydrant': fireHydrantIcon(false, true),
  'unknown-sign': signIcon(true),
  'traffic-light': trafficLightIcon(false, true),
  'speed-sign': speedLimitIconGeneric(false, true),
  'parking-restriction': noParkingIcon(false, true),
  'stop-sign': stopSignIcon(false, true),
  'turn-rules-sign': turnRuleIcon(false, true),
  'highway-sign': highwaySignIcon(true),
  'speed-sign-eu': speedSignEUIcon(true),
  'turn-rules-eu': turnRuleEUIcon(true),
  'movement-regulation-sign': trafficFlowIcon(true),
};

export function getClassLabelIcon(
  classLabel: ClassLabel,
  isGrayScale?: boolean,
  isMapFeature?: boolean,
): string {
  if (isMapFeature) {
    return (
      CLASS_LABEL_ICONS_MAP_FEATURE[classLabel] ??
      CLASS_LABEL_ICONS['unknown-sign']!
    );
  }
  if (isGrayScale) {
    return (
      CLASS_LABEL_ICONS_GRAYSCALE[classLabel] ??
      CLASS_LABEL_ICONS['unknown-sign']!
    );
  }
  return CLASS_LABEL_ICONS[classLabel] ?? CLASS_LABEL_ICONS['unknown-sign']!;
}
